/* Retire campaign messaging in tabs that stay open past the end date. */
(() => {
  const expires = Date.parse('2026-10-18T21:59:59Z');
  const refresh = () => {
    if (Date.now() >= expires) {
      document.querySelectorAll('[data-bbb-reima-promo]').forEach(el => { el.hidden = true; });
    }
  };
  refresh();
  document.addEventListener('visibilitychange', refresh);
  document.addEventListener('shopify:section:load', refresh);
  setInterval(refresh, 60000);
})();
